import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, patch, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface GetAddAccountParamater extends ApiParameter {
    email: string;
    firstName: string;
    lastName: string;
    properties: Properties;
}

export interface AddAccountResultModel {
    uri: any;
    toEmail: string;
    emailSent: boolean;
    properties: Properties2;
}

export interface Properties {
    isBecomeACustomerPage: boolean | string;
    phone: string;
    captchaResponse: string;
}

export interface Properties2 {
    isUserExists: string;
}

export interface GetAddAccountModel extends BaseModel {
    addAccount: AddAccountResultModel;
}

const url = "/api/v2/accounts";

export async function addADIAccount(parameter: GetAddAccountParamater): Promise<ServiceResult<GetAddAccountModel>> {
    try {
        const resultModel = await patch<GetAddAccountModel>(`${url}`, parameter as any);
        return {
            result: resultModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
